import { EventHandler } from "../../util/event/EventHandler";
import { ResultCode } from "../common/controller/net/constant/Constants";
import { GetSettingsRequest } from "../common/controller/net/request/GetSettingsRequest";
import { AbstractHandler } from "../core/handler/AbstractHandler";
import { GetSettingsResult } from "./GetSettingsResult";
/**
 * GetSettingsHandler.ts
 */
export class GetSettingsHandler extends AbstractHandler {
    constructor(params, action, scope) {
        super();
        this.params = params;
        this.eventHandler = new EventHandler(action, scope);
    }
    destroy() {
        super.destroy();
        this.eventHandler = null;
    }
    run() {
        super.run();
        this.send();
    }
    send() {
        let request = new GetSettingsRequest(this.params);
        request.onSuccess(this.handleSuccess, this);
        request.onFailure(this.handleFailed, this);
        request.send();
    }
    handleSuccess(data) {
        this.handleAction(new GetSettingsResult(ResultCode.SUCCESS, data));
    }
    handleFailed(data) {
        this.handleAction(new GetSettingsResult(data.getResponseCode()));
    }
    handleAction(result) {
        this.eventHandler.call(result);
        this.destroy();
    }
}
//# sourceMappingURL=GetSettingsHandler.js.map